import { render, staticRenderFns } from "./otaActivate.vue?vue&type=template&id=66c59fef&"
import script from "./otaActivate.vue?vue&type=script&lang=js&"
export * from "./otaActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports